import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Flame, PhoneCall, CalendarCheck, Trophy } from "lucide-react";

export default function CallBoard({ refreshKey }) {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/prospector/call-board").then(({ data }) => setD(data)).catch(() => {}); }, [refreshKey]);
  if (!d) return null;
  return (
    <div className="rounded-xl border border-border bg-white p-4" data-testid="call-board">
      <div className="flex items-center gap-2"><Trophy className="h-4 w-4 text-sam-amber" /><h3 className="font-display text-lg font-bold text-sam-navy">This week's call board</h3></div>
      <p className="text-xs text-sam-slate">Ranked by appointments booked, then calls made. Week of {d.week_start}.</p>
      <div className="mt-2 rounded-lg bg-sam-navy/5 p-2 text-sm text-sam-navy" data-testid="call-board-me">
        You: <b>{d.me.calls}</b> calls · <b>{d.me.booked}</b> booked{d.me.rank ? ` · #${d.me.rank} of ${d.reps}` : ""}
        {d.me.streak >= 2 && <Badge className="ml-2 bg-orange-500" data-testid="call-board-my-streak"><Flame className="mr-1 h-3 w-3" />{d.me.streak}-wk booking streak</Badge>}
      </div>
      <ol className="mt-2 divide-y divide-border">
        {d.rows.map((r) => (
          <li key={r.user_id} className={`flex items-center gap-2 py-1.5 text-sm ${r.me ? "font-bold" : ""}`} data-testid={`call-board-row-${r.rank}`}>
            <span className="w-6 text-sam-slate">#{r.rank}</span>
            <span className="flex-1 truncate text-sam-navy">{r.me ? "You" : r.name}</span>
            {r.streak >= 2 && <Flame className="h-3.5 w-3.5 text-orange-500" aria-label={`${r.streak}-week streak`} />}
            <span className="inline-flex items-center gap-1 text-xs text-sam-slate"><PhoneCall className="h-3 w-3" />{r.calls}</span>
            <span className="inline-flex items-center gap-1 text-xs font-semibold text-sam-green"><CalendarCheck className="h-3 w-3" />{r.booked}</span>
          </li>
        ))}
      </ol>
      {!d.rows.length && <p className="mt-2 text-xs text-sam-slate" data-testid="call-board-empty">No calls logged yet this week. Be the first on the board.</p>}
    </div>
  );
}
